module.exports = __webpack_public_path__ + "img/jisukuaile_icon.e09e6753.png";